import { EnvelopeCover } from "@/components/envolope-cover";
import { GreetingPage } from "@/components/greeting-page";
import Hero from "@/components/hero";
import Invite from "@/components/invite";
import { Rsvp } from "@/components/rsvp";
import { ScrollIndicator } from "@/components/scroll-indicator";

export const Root = () => {
    return (
        <>
            <EnvelopeCover />
            <GreetingPage />
            <main className="min-h-screen bg-background font-semi-bold">
                <Hero />
                <ScrollIndicator />
                <div className="flex min-h-screen flex-col items-center justify-center overflow-hidden px-4 py-8">
                    <Invite />
                    {/* <Rsvp /> */}
                </div>
            </main>
        </>
    );
}